import React, { useState, useEffect, useRef } from 'react'
import classNames from 'classnames'

import TextInput from '../../TextInput/TextInput'
import DropDownLite from '../RenderAdvanceQuery/DropDownLite'

import { getFileSizes, tableFilterKeyBindingHelper } from '../util/helper'

const RenderFileSizeField = (props) => {

  const ref = useRef(null)

  const { queryObj, queryObjIndex, queryIndex, type, activeSuggestionIndex } = props
  const isAutoCompleteOpen = `${queryObj.cursorY}-${queryObjIndex}-${queryIndex}-${type}` === activeSuggestionIndex

  const { value = [] } = props.query

  let [inputValue, setInputValue] = useState('')

  const handleInputChange = (e) => {
    const value = e.target.value
    setInputValue(value)
  }

  const prepareCloseDropdown = () => {
    setInputValue('')
    props.closeAutoComplete()
  }

  const handleOptionSelect = (e, selectedOpt) => {
    const updatedCurrentQuery = { ...props.query, value: [selectedOpt], valueError: false }
    props.updateAdvancedQueryArray({
      currentQuery: updatedCurrentQuery,
      queryArray: props.queryArray,
      currentQueryIndex: queryIndex,
      action: 'updateQueryArray',
      queryObject: props.queryObj,
      parentQueryObject: props.parentQueryObject
    })
    prepareCloseDropdown()
  }

  const handleKeyBindings = (e) => {
    const { key } = e
    if (!props.isVisible) return

    if (isAutoCompleteOpen) {
      tableFilterKeyBindingHelper(e, `AdvancedQueryView__suggestion-items-dropdownlite`)
      if (key === 'Escape') {
        props.closeAutoComplete()
      }
    }

    if (key === 'Enter' && props.isValueActive) {
      ref.current.click()
    }
  }

  useEffect(() => {
    document.addEventListener('keyup', handleKeyBindings, false)

    return () => {
      document.removeEventListener('keyup', handleKeyBindings, false)
    }
  }, [props.isValueActive, ref, props.isVisible, isAutoCompleteOpen])

  if (!isAutoCompleteOpen) {
    return (
      <div
        data-test-id="cs-advance-search-select-value"
        className={classNames(
          'query-value',
          props.type === 'key' && 'query-key-label',
          props.query.valueError && 'query-value-error',
          props.placeholderClass,
          props.isValueActive && 'query-value-active'
        )}
        ref={ref}
        onClick={(e) => {
          setInputValue(value[0]?.enteredValue || '')
          props.openAutoComplete(e, props.type)
        }}>
        <div className="query-value-textTruncate">{value[0]?.label || 'Type Value'}</div>
      </div>
    )
  }

  const fileSizeOptions = getFileSizes({ inputValue: parseInt(inputValue) })
  return (
    <div className="query-value-textInput">
      <TextInput
        type={'number'}
        placeholder="Type Value"
        version="v2"
        width="full"
        value={inputValue}
        onChange={handleInputChange}
        autoFocus
        onBlur={() => {
          //close closeAutoComplete when user clear field manually
          if (!inputValue) {
            props.closeAutoComplete()
          }
        }}
        onKeyDown={(e) => {
          if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
            e.preventDefault()
            return
          }
        }}
      />
      {inputValue && (
        <DropDownLite
          optionList={fileSizeOptions}
          closeDropdown={prepareCloseDropdown}
          handleChangeOption={handleOptionSelect}
        />
      )}
    </div>
  )
}

export default RenderFileSizeField
